import { render } from "./Footer.vue?vue&type=template&id=0206407c"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=0206407c&lang=css"
script.render = render

export default script